import {
  createTheme as createMuiTheme,
  Theme as MuiThemeInterface,
  ThemeOptions as MuiThemeOptions,
} from '@mui/material';
import { frFR as coreFrFR } from '@mui/material/locale';
import type { Shadows } from '@mui/material/styles/shadows';
import { frFR } from '@mui/x-data-grid';
import merge from 'lodash.merge';

import { themeCommon } from './common';

declare module '@mui/material/styles' {
  interface TypographyVariants {
    fontFamilySecondary: string;
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    fontFamilySecondary?: string;
  }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    fontFamilySecondary: string;
  }
}

interface CustomProperties {
  scrollbar: {
    thumb: { main: string; hover: string };
  };
  icons: {
    logo: string;
    logoIcon: string;
  };
  shadowsInset: Shadows;
  googleMapStyles?: Array<google.maps.MapTypeStyle>;
}

export interface ThemeOptions extends MuiThemeOptions, CustomProperties {}

export type Theme = MuiThemeInterface &
  CustomProperties & {
    shape: Omit<MuiThemeInterface['shape'], 'borderRadius'> & {
      borderRadius: number;
    };
    mixins: {
      toolbar: {
        height: number;
      };
    };
  };

export const createTheme = (themeOptions: ThemeOptions) =>
  createMuiTheme(merge(themeCommon, themeOptions), coreFrFR, frFR);
